<template lang='pug' src='./pedo.pug'></template>

<script>
import BabyTeeth from 'components/custom/custom-pedo-baby-teeth/custom-pedo-baby-teeth'
import Care from 'components/custom/custom-pedo-care/custom-pedo-care'
import Caries from 'components/custom/custom-pedo-caries/custom-pedo-caries'
import Exam from 'components/custom/custom-pedo-exams/custom-pedo-exams'
import Fillings from 'components/custom/custom-pedo-fillings/custom-pedo-fillings'
import Hero from 'components/hero/hero-pages/hero-pages'
import Loader from 'components/loader/loader'
import Nitrous from 'components/custom/custom-pedo-nitrous/custom-pedo-nitrous'
import Nutrition from 'components/custom/custom-pedo-nutrition/custom-pedo-nutrition'
import OralHabits from 'components/custom/custom-pedo-habits/custom-pedo-habits'
import PedoFaq from 'components/custom/custom-pedo-faq/custom-pedo-faq'

export default {
  name: 'pedo',
  computed: {
    props () {
      return this.$store.state.pages['pediatric-dentistry']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
    BabyTeeth,
    Care,
    Caries,
    Exam,
    Fillings,
    Hero,
    Loader,
    Nitrous,
    Nutrition,
    OralHabits,
    PedoFaq
  }
}
</script>



// WEBPACK FOOTER //
// pedo.vue?78141a4a